import BackendGateway from "lib/gateway/backend-gateway";
import { normalizer } from "lib/normalizer/permissions-normalizer";

class CurrentUserRepository {
  /**
   * @type BackendGateway
   */
  #backendGateway;

  constructor(backendGateway) {
    this.#backendGateway = backendGateway;
  }

  getCurrentUserPermissions(userParams) {
    return this.#backendGateway
      .fetchCurrentUserPermissions(userParams)
      .then((permissions) => normalizer(permissions));
  }
}
export default new CurrentUserRepository(BackendGateway);
